import React from 'react';
import { FormGroup, Button, Label } from 'reactstrap';
import ActionContainer from '../../containers/workflow/ActionContainer'
import ActionButtonGatway from '../../containers/workflow/ActionButtonGatway';

const ActionButton = (props) => {
    const { label,
        placeholder,
        classProperty,
        isReadOne,
        value,
        onLayoutItemChanged,
        layoutItem,
        layoutItem: { itemProperties: { generatedActionCodeForAllowAddition } },
        workflowData,
        containerIndex
    } = props;
    const actions = props.workflow.currentItem.inlineAction;
    let action = null;
    actions.forEach(element => {
        if (element.actionProperties.generatedActionCode === generatedActionCodeForAllowAddition)
            action = element;
    });
    let isActionButtonGateway = layoutItem &&
        layoutItem.itemProperties &&
        layoutItem.itemProperties.actionButtonConfig &&
        layoutItem.itemProperties.actionButtonConfig.isActionButtonGateway
    let gatewayProvide = layoutItem &&
        layoutItem.itemProperties &&
        layoutItem.itemProperties.actionButtonConfig &&
        layoutItem.itemProperties.actionButtonConfig.gatewayProvide &&
        layoutItem.itemProperties.actionButtonConfig.gatewayProvide.value;


    let condition = !action && !isActionButtonGateway && !gatewayProvide
    console.log(`con`, condition, isActionButtonGateway, gatewayProvide)

    if (isActionButtonGateway && gatewayProvide) {

    } else if (!action) {
        return null;
    }

    // if (!action) return null;
    const tid = workflowData && workflowData.id;
    const cid = typeof containerIndex != 'undefined' ? containerIndex : props.containerId;
    return (
        <div>
            {
                layoutItem && layoutItem.itemProperties &&
                    layoutItem.itemProperties.actionButtonConfig &&
                    layoutItem.itemProperties.actionButtonConfig.isActionButtonGateway &&
                    layoutItem.itemProperties.actionButtonConfig.gatewayProvide &&
                    layoutItem.itemProperties.actionButtonConfig.gatewayProvide.value ?
                    <ActionButtonGatway action={action} tid={tid} containerId={cid} {...props}></ActionButtonGatway>
                    :

                    <ActionContainer action={action} tid={tid} containerId={cid} {...props} >
                    </ActionContainer>
            }
        </div>


    );
}

export default ActionButton;